// TODO: Refactor the color codes
import styled from 'styled-components'
import { color, variant, typography, layout } from 'styled-system'

const StyledButton = styled.button`  
  height: auto;
  background-color: transparent;
  border-radius: 4px;
  border: none;
  transition: background-color 0.25s, background-image 0.25s;
  ${color}
  ${typography}
  ${layout}
  ${variant({
    variants: {
      primary: {
        height: 48,
        backgroundImage: 'linear-gradient(96deg, #0099ff, #0055ff 100%)',
        color: 'light-1',
        border: 'none',
        '&:hover': {
          backgroundImage: 'linear-gradient(96deg, #0092ff, #0055ff)'
        },
        '&:active': {
          backgroundImage: 'linear-gradient(96deg, #0092ff, #0055ff)'
        }
      },
      secondary: {
        height: 48,
        bg: 'light-1',
        color: 'primary-1',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'primary-1'
      },
      transparent: {
        height: 48,
        bg: 'transparent',
        color: 'light-1',
        borderWidth: '1px',
        borderStyle: 'solid',
        borderColor: 'light-1',
        '&:hover': {
          bg: 'light-1',
          color: 'primary-1'
        },
        '&:active': {
          bg: 'rgba(0, 85, 255, 0.32)'
        }
      },
      blank: {}
    }
  })}
`
StyledButton.defaultProps = {
  variant: 'primary',
  fontSize: 'text.regular',
  lineHeight: 'text.regular',
  fontWeight: 'bold'
}

const Button = ({
  variant = 'primary',
  block = false,
  children,
  ...others
}) => (
  <StyledButton variant={variant} width={block ? '100%' : ''} {...others}>
    {children}
  </StyledButton>
)

export default Button
